import { useTranslation } from 'react-i18next';
import { useToast } from '@pcmp/react-providers';
import { LoadingFullScreen } from '@/components/helpers/loading';
import { usePostV2QrCodesBySlugRestoreMutation } from '@/redux/apis/codes-api';
import { useGetV1UsersMeQuery } from '@/redux/apis/frontend-api';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

function CodeRestorePage() {
  const { data: userData } = useGetV1UsersMeQuery();
  const { slug } = useParams<{ slug: string }>();
  const effectiveSlug = slug ?? '';

  const [restoreCode] = usePostV2QrCodesBySlugRestoreMutation();
  const navigate = useNavigate();
  const { pushToast } = useToast();
  const { t } = useTranslation();

  const handleRestoreCode = async () => {
    if (!effectiveSlug) return;

    const response = await restoreCode({ slug: effectiveSlug });
    const isError = response && 'error' in response;
    const status = isError ? 'error' : 'success';
    const message = t(`page.codes.restore.${status}`);

    pushToast({ message });

    if (!isError) {
      navigate(`/codes/${effectiveSlug}`);
    }
  };

  useEffect(() => {
    if (!userData) {
      pushToast({ message: t('page.codes.restore.error') });
      return;
    }

    handleRestoreCode();
  }, [userData]);

  if (!userData || !effectiveSlug) return <LoadingFullScreen />;
  return <LoadingFullScreen />;
}

export default CodeRestorePage;
